import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import ColorInput from 'components/Tvendo/Common/ColorInput';

export default function ModalCustomerColor(props) {
  const color = props.model;
  const [hex, setHex] = React.useState(color?.code || '#37FFF6');

  React.useEffect(() => {
    setHex(color?.code || '#37FFF6');
  }, [color]);

  return (
    <Modal
      title="Color del aplicativo"
      model={color}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="ordm/customer-color"
    >
      <ColorInput
        label="Color"
        name="code"
        color={hex}
        setColor={setHex}
        showLayerIcon
        required
      />

      <TextField
        label="Tipo"
        name="type"
        select
        SelectProps={{ native: true }}
        margin="normal"
        fullWidth
        defaultValue={color?.type || 'C'}
        required
      >
        <option value="C">Clientes</option>
        <option value="P">Pedidos</option>
      </TextField>

      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={color?.description || ''}
        helperText="Para qué se usa este color"
        required
      />
    </Modal>
  );
}
